import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { id } from '@swimlane/ngx-charts';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { IstatusCountData } from 'src/app/post-login/services/on-demand-classes.service.model';
import {
  DetaildViewHeadersOptions,
  DetailedViewHeaders,
  DetailsViewDataModel,
  StatsData,
} from 'src/app/post-login/services/stats.model';

@Component({
  selector: 'app-details-view-grid',
  templateUrl: './details-view-grid.component.html',
  styleUrls: ['./details-view-grid.component.scss'],
})
export class DetailsViewGridComponent implements OnInit {
  hideme = [];
  distance = DetaildViewHeadersOptions.TOTAL_DISTANCE;
  hours = DetaildViewHeadersOptions.TOTAL_HOURS;
  radio = false;
  unit: string | undefined = '';
  @Input() statusCountList: IstatusCountData;
  @Input() headers: DetailedViewHeaders;
  @Input() data: DetailsViewDataModel[];
  @Input() connectedCount: number;
  @Input() notConnectedCount: number;
  @Input() idle: number;
  @Input() service: number;
  @Input() filterList: StatsData[];
  @Input() doNotShowParent: boolean;
  rootScopeData: RootScopeDeclare;
  constructor(private rootScopeService: RootScopeService, private commonUtil: CommonUtil, private _router: Router,) {
    this.getRootScopeData();
  }

  ngOnInit(): void {
    let connected = 0;
    let disconected = 0;
    let idle = 0;
    this.data.forEach(item => {
      disconected += Number(item.statsData?.disconnectedEquipCount != null ? item.statsData?.disconnectedEquipCount : 0);
      connected += Number(item.statsData?.connectedEquipCount != null ? item.statsData?.connectedEquipCount : 0);
      idle += Number(item.statsData?.idleEquipCount != null ? item.statsData?.idleEquipCount : 0);
    });
    this.statusCountList = {
      connectedCount: connected,
      idleCount: idle,
      notConnectedCount: disconected,
      showIdle: true
    };
  }

  ngOnChanges(changes:SimpleChanges){
    if(changes.data && changes.data.currentValue && changes.data.currentValue !== changes.data.previousValue){
      //Reset Filter Control & Hide the options.
      this.hideme = [];
    }
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData
      this.unit = this.rootScopeData.preferredUnit === 'I' ? 'Mi' : 'Km';
    });
  }

  closeHeader(i:number){
    this.hideme[i] = !this.hideme[i] as never;
    for (let j = 0; j < 3; j++) {
      if(i != j) {
        this.hideme[j] = false as never;
      }
    }
  }

  handleChange(e: any, option: any, row: any) {
    this.hideme[2] = false as never;
    this.hideme[1] = false as never;
    this.hideme[0] = false as never;
    switch (option) {
      case 'totalDistance':
        row.label = this.commonUtil.translateText('TOTAL.DISTANCE');
        this.distance = DetaildViewHeadersOptions.TOTAL_DISTANCE;
        break;
      case 'totalTreadMillBeltDistance':
        row.label = this.commonUtil.translateText('TOTAL.BELT.DISTANCE');
        this.distance = DetaildViewHeadersOptions.TOTAL_BELT_DISTANCE;
        break;
      case 'totalHours':
        row.label = this.commonUtil.translateText('TOTAL.HOURS');
        this.hours = DetaildViewHeadersOptions.TOTAL_HOURS;
        break;
      case 'totalTreadMillBeltHours':
        row.label = this.commonUtil.translateText('TOTAL.BELT.HOURS');
        this.hours = DetaildViewHeadersOptions.TOTAL_BELT_HOURS;
        break;
      case 'totalTreadMillLiftHours':
        row.label = this.commonUtil.translateText('TOTAL.LIFT.HOURS');
        this.hours = DetaildViewHeadersOptions.TOTAL_LIFT_HOURS;
        break;
      default:
        break;
    }
  }

  expand(i: number) {
    this.data[i].expanded = this.data[i].expanded == undefined ? true : !this.data[i].expanded;
    this.data.forEach((element, index) => {
      if(index != i) {
        element.expanded = false;
      }
    });
  }

  tryToMoveAwayFromCurrentPage(path: string) {
    this.rootScopeData.pathToNavigate = path;
    if (this.rootScopeData.pathToNavigate.indexOf('app.html') >= 0) {
      window.location.href = this.rootScopeData.pathToNavigate;
    } else if (this.rootScopeData.pathToNavigate !== this._router.url) {
      window.location.href ='halo.html#'+ this.rootScopeData.pathToNavigate;
    }else{
      window.location.href=path;
    }
  }
}
